import { render } from "./BankStatement.vue?vue&type=template&id=02084ffe"
import script from "./BankStatement.vue?vue&type=script&lang=js"
export * from "./BankStatement.vue?vue&type=script&lang=js"
script.render = render

export default script